import { io, Socket } from 'socket.io-client';

class SocketServiceClass {
  private socket: Socket | null = null;

  connect() {
    if (!this.socket) {
      // 临时硬编码用于测试（请在测试后恢复环境变量方式）
      const API_BASE_URL = 'https://data-management-system-production.up.railway.app';
      // const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      this.socket = io(API_BASE_URL);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  on(event: string, callback: (data: any) => void) {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  off(event: string) {
    if (this.socket) {
      this.socket.off(event);
    }
  }
}

export const SocketService = new SocketServiceClass();